import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography
} from '@mui/material';
import NavbarUni from './componentes/headUni';
import { Container } from "react-bootstrap";
import { Truck, CreditCard, ShieldLock, ArrowsAngleExpand } from "react-bootstrap-icons";
import FooterPublic from './FooterPublic';
import Marquee from './componentes/marquee';

const brandColor = "#e2304a";

const faqs = [
    {
        q: "¿Manejan pago contra entrega?",
        a: "Manejamos contra entrega a cuidades seleccionadas pero no a todo el país."
    },
    {
        q: "¿Cuánto cuesta el envío?",
        a: "Puedes calcularlo directamente en el catálogo o con interrapidisimo que es la transportadora por donde hacemos los envios."
    },
    {
        q: "¿Dónde están ubicados?",
        a: "Estamos ubicados en Bogotá - Cundinamarca. calle 57A #78K-04 sur, Barrio Roma, Kennedy"
    },
    {
        q: "¿Dirección exacta?",
        a: "Bogotá - Cundinamarca. calle 57A #78K-04 sur, Barrio Roma, Kennedy. Si no estas en la cuidad realizamos envio a nivel nacional"
    },
    {
        q: "¿Por qué confiar en nosotros?",
        a: "Tenemos más de 5,000 gorras en stock y validación previa del pedido."
    }
];

const PreguntasFrecuentes = () => {
    const [expanded, setExpanded] = useState(null);

    const handleChange = (panel) => {
        setExpanded(expanded === panel ? null : panel);
    };

    return (
        <div>
            <Marquee />
            <NavbarUni />

            {/* HEADER NUEVO */}
            <div
                style={{
                    padding: "30px 20px",
                    borderBottomLeftRadius: "25px",
                    borderBottomRightRadius: "25px",
                    textAlign: "center",
                }}
            >
                <h2 className='text1-cr' style={{ margin: 0, fontWeight: "bold" }}>
                    Centro de Ayuda
                </h2>
                <p className='text1-cr' style={{ margin: "5px 0 0", fontSize: "0.9rem", opacity: 0.9 }}>
                    Resolvemos tus dudas en segundos
                </p>
            </div>

            <Container style={{ marginTop: "-20px" }}>

                {/* BENEFICIOS */}
                <div style={{ marginBottom: "25px" }}>
                    {[{
                        icon: <Truck size={22} />,
                        title: "Envíos Contra entrega",
                        text: "A gran parte de Colombia"
                    }, {
                        icon: <CreditCard size={22} />,
                        title: "Paga como quieras",
                        text: "Múltiples métodos"
                    }, {
                        icon: <ShieldLock size={22} />,
                        title: "Compra segura",
                        text: "Protección total y envio seguro"
                    }].map((item, i) => (
                        <div
                            key={i}
                            style={{
                                background: "#fff",
                                borderRadius: "14px",
                                padding: "14px",
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "10px",
                                boxShadow: "0 3px 10px rgba(0,0,0,0.05)"
                            }}
                        >
                            <div
                                style={{
                                    background: `${brandColor}15`,
                                    color: brandColor,
                                    borderRadius: "10px",
                                    padding: "10px",
                                    marginRight: "12px"
                                }}
                            >
                                {item.icon}
                            </div>

                            <div>
                                <strong style={{ fontSize: "0.95rem" }}>{item.title}</strong>
                                <p className='text1-cr' style={{ margin: 0, fontSize: "0.8rem" }}>
                                    {item.text}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* FAQ */}
                {faqs.map((item, i) => (
                    <Accordion
                        key={i}
                        expanded={expanded === i}
                        onChange={() => handleChange(i)}
                        sx={{
                            mb: 1.5,
                            borderRadius: "14px !important",
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            '&:before': { display: 'none' }
                        }}
                    >
                        <AccordionSummary
                            sx={{
                                background: expanded === i ? brandColor : "#fff",
                                color: expanded === i ? "#fff" : "#000",
                                minHeight: "60px"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "space-between"
                                }}
                            >
                                <Typography sx={{ fontWeight: "600", fontSize: "0.95rem" }}>
                                    {item.q}
                                </Typography>

                                <ArrowsAngleExpand
                                    style={{
                                        transition: "0.3s",
                                        transform: expanded === i ? "rotate(180deg)" : "rotate(0deg)"
                                    }}
                                />
                            </div>
                        </AccordionSummary>

                        <AccordionDetails sx={{ background: "#fff" }}>
                            <Typography sx={{ fontSize: "0.9rem", color: "#555" }}>
                                {item.a}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}

            </Container>

            <FooterPublic />
            {/* BOTÓN FLOTANTE WHATSAPP */}
            <a
                href="https://wa.me/573151774727?text=Hola,%20tengo%20una%20pregunta.%20Vengo%20de%20su%20pagina%20web."
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    zIndex: 999,
                    background: "#25D366",
                    borderRadius: "50%",
                    width: "55px",
                    height: "55px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                    transition: "transform 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="#fff"
                    viewBox="0 0 16 16"
                >
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 8.007 0C3.589 0 .002 3.587 0 8.007a7.96 7.96 0 0 0 1.1 4.02L0 16l4.082-1.066a7.94 7.94 0 0 0 3.925 1.002h.003c4.418 0 8.005-3.587 8.007-8.007a7.85 7.85 0 0 0-2.416-5.603zM8.01 14.54a6.52 6.52 0 0 1-3.316-.907l-.238-.14-2.422.633.647-2.361-.154-.243a6.48 6.48 0 0 1-.997-3.514c.002-3.592 2.92-6.51 6.513-6.51a6.46 6.46 0 0 1 4.605 1.905 6.46 6.46 0 0 1 1.906 4.605c-.002 3.592-2.92 6.51-6.514 6.51zm3.58-4.864c-.196-.098-1.157-.57-1.337-.635-.18-.066-.31-.098-.44.098-.13.196-.505.635-.619.766-.114.13-.228.147-.424.049-.196-.098-.828-.305-1.577-.973-.582-.52-.975-1.162-1.09-1.358-.114-.196-.012-.302.086-.4.088-.087.196-.228.294-.342.098-.114.13-.196.196-.327.065-.13.033-.245-.016-.343-.049-.098-.44-1.06-.602-1.45-.158-.379-.319-.327-.44-.333-.114-.006-.245-.007-.376-.007-.13 0-.343.049-.522.245-.18.196-.686.67-.686 1.634 0 .964.702 1.895.8 2.025.098.13 1.382 2.11 3.35 2.957.469.202.835.323 1.12.414.47.15.897.129 1.235.078.377-.056 1.157-.473 1.321-.93.163-.457.163-.848.114-.93-.049-.082-.18-.13-.376-.228z" />
                </svg>
            </a>
        </div>
    );
};

export default PreguntasFrecuentes;